<template>
	<div class = "box">
		<div class = "his-order-div">
			<OrderList :code="code" @loadCode="loadNowCode()"></OrderList>
		</div>
		
		<div class="emtry-div"></div>
		<HistoryOrderTabbar></HistoryOrderTabbar>
	</div>
</template>

<script>
	import OrderList from '../components/historyOrder/OrderList.vue'
	import HistoryOrderTabbar from '../components/historyOrder/HistoryOrderTabbar.vue'
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'historyOrder',
		computed: mapGetters(["sOrderCode"]),
		components: {
		      [HistoryOrderTabbar.name]: HistoryOrderTabbar,
		      [OrderList.name]: OrderList,
		 },
		data(){
			return {
				code:'',
			}
		},
		created() {
			// this.sSetCouponId(null)
			// this.init()
		},
		methods:{
			...mapMutations(['setOrderCode','sSetCouponId']),
			init(){
				let browserFlag = this.isWechat()
				if (browserFlag == 0) {
					let code = this.$getUrlParam("code")
					if (!code && !this.sOrderCode) {
						this.getCode()
					} else {
						if(code){
							this.setOrderCode(code)
							let uri =  window.location.href
							uri = uri.split("?")[0]+'#/historyOrder'
							window.location.replace(uri)
						}else{
							this.code = this.sOrderCode
							this.setOrderCode('')
						}
					}
				}
			},
			loadNowCode(){
				this.code =''
				this.init()
			},
			getCode() {
				// console.log(window.location.href)
				// let payBack = "https://kf.xty86.com/#/historyOrder"
				let payBack = window.location.href
				// let payBack = "https://atest.xty86.com/#/historyOrder"
				// 正式环境
				let appId = "wx3de49bcab72a4020"
				// 测试环境公众号ID
				// let appId="wxeade3e34841010b2"
				let codeUri = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" +
					encodeURIComponent(payBack) + "&response_type=code&scope=snsapi_base#wechat_redirect"
				window.location.href = codeUri
			},
			isWechat() {
				var ua = window.navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == "micromessenger") {
					return 0
				} else {
					return 1
				}
			},
			getUrlParam(name) {
				var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
				let url = window.location.href.split('#')[0]
				let search = url.split('?')[1]
				if (search) {
					var r = search.substr(0).match(reg)
					if (r !== null) return unescape(r[2])
					return null
				} else {
					return null
				}
			},
		}
	}
</script>

<style scoped>
	
	.box {
		width: 100%;
		min-height: 100%;
		background-color: #f6f6f6;
	}
	.his-order-div {
		padding: 0px 15px;
	}
	
	.emtry-div {
		width: 100%;
		height: 70px;
	}
	
</style>
